import { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useLangTranslation } from '../utils/translation';

const languages = [
  ['ko', '한국어', '🇰🇷'], ['en', 'English', '🇺🇸'], ['ja', '日本語', '🇯🇵'],
  ['de', 'Deutsch', '🇩🇪'], ['es', 'Español', '🇪🇸'], ['fr', 'Français', '🇫🇷'],
  ['th', 'ภาษาไทย', '🇹🇭'], ['zh-cn', '简体中文', '🇨🇳'], ['zh-tw', '繁體中文', '🇹🇼'],
];

export default function LanguageSelector({ drawerOpen, onOpen }) {
  const { lang = 'en' } = useParams();
  const location = useLocation();
  const t = useLangTranslation('common');
  const [open, setOpen] = useState(false);
  const root = useRef(null);
  const trigger = useRef(null);
  const selected = languages.find(([code]) => code === lang) || languages[1];
  useEffect(() => setOpen(false), [location]);
  useEffect(() => { if (drawerOpen) setOpen(false); }, [drawerOpen]);
  useEffect(() => {
    if (!open) return;
    const outside = event => { if (!root.current?.contains(event.target)) setOpen(false); };
    const escape = event => { if (event.key === 'Escape') { setOpen(false); trigger.current?.focus(); } };
    document.addEventListener('pointerdown', outside);
    document.addEventListener('keydown', escape);
    return () => { document.removeEventListener('pointerdown', outside); document.removeEventListener('keydown', escape); };
  }, [open]);
  return <div className="header-language" ref={root} inert={drawerOpen ? true : undefined} onBlur={event => {
    if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false);
  }}>
    <button ref={trigger} className="language-trigger" aria-label={`${t('footer.language.select')}: ${selected[1]}`} aria-expanded={open} aria-controls="header-language-options" onClick={() => {
      if (!open) onOpen();
      setOpen(value => !value);
    }}>
      <span className="language-flag" aria-hidden="true">{selected[2]}</span>
      <span className="language-current-name">{selected[1]}</span>
      <svg className="language-chevron" width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="m3 4.5 3 3 3-3" stroke="currentColor" strokeWidth="1.4" /></svg>
    </button>
    <nav id="header-language-options" className="language-options" aria-label={t('footer.language.select')} hidden={!open}>
      {languages.map(([code, label, flag]) => <Link key={code} lang={code} hrefLang={code} aria-current={code === lang ? 'true' : undefined} to={{ pathname: '/' + code + location.pathname.replace(/^\/[^/]+/, ''), search: location.search, hash: location.hash }} onClick={() => { setOpen(false); trigger.current?.focus(); }}>
        <span className="language-flag" aria-hidden="true">{flag}</span><span>{label}</span><span className="language-check" aria-hidden="true">{code === lang ? '✓' : ''}</span>
      </Link>)}
    </nav>
  </div>;
}
